<!--~
~ Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
~ to an End-User License Agreement included in a separate file named EULA.txt
~ that is distributed with this file.
-->
@if (hasStreetView) {
    <div
        (click)="launchStreetView()"
        class="dash-gis-parcel-image-container" #parcelImageContainer>
        <img id="parcelImage"
             [class.loaded]="parcelImageLoaded"
             [src]="streetViewStaticUrl$ | async"
             (load)="onImageLoaded()"
             alt="Street View Image" />
    </div>
}
<div class="report-container dash-gis-feature-report-container" fxFlex="1 1 auto" fxLayout="column">
    @if (hasStreetView) {
        <div class="dash-gis-parcel-address-container">
            @if (parcelDisplayAddress$|async; as streetViewAddress) {
                <div
                    class="dash-gis-parcel-address selectable-text">
                    <span class="dash-gis-address-1">{{ streetViewAddress.address1 }}</span><br />
                    <span class="dash-gis-address-2">{{ streetViewAddress.address2 }}</span>
                </div>
            }
        </div>
    }
    @if (showControls) {
        <dash-gis-report-controls
            [definition]="definition"
            [keys]="featureReportKeys$ | async"
            [digitizeKey]="digitizeKey$ | async"></dash-gis-report-controls>
    }
    <dash-gis-report-content-container [keys]="featureReportKeys$ | async"
                                       [definition]="definition"
                                       (recordCount)="setRecordCount($event)"
                                       fxFlex fxLayout="column"></dash-gis-report-content-container>
</div>
